$(document).ready(function(){

  // -- BLOCK GALLERY --
  // --------------------

  $('.slick--blockGallery').each(function() {
    $(this).slick({
      infinite: false,
      slidesToShow: 2,
      appendArrows: $(this).next('.slider__nav'),
      appendDots: $(this).next('.slider__nav'),
      arrows: true,
      dots: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  });


	// var blockGallerySettings = {
	//   arrows: false,
	//   dots: true,
	//   infinite: false,
 //    slidesToShow: 2,
	//   responsive: [{
 //      breakpoint: 768,
 //      settings: {
 //        slidesToShow: 1,
 //      }
 //    }]
	// };

	// // -- Init --
	// $('.slick--blockGallery').slick(blockGallerySettings);

	// // -- Prev --
 //  $('.blockGallery').on('click', '.arrow--prev', function(){
 //  	$(this).parents('.blockGallery').find('.slick--blockGallery').slick('slickPrev');
 //  });

 // 	// -- Next --
 //  $('.blockGallery').on('click', '.arrow--next', function(){
 //  	$(this).parents('.blockGallery').find('.slick--blockGallery').slick('slickNext');
 //  });


  // -- HOMEPAGE --
  // ---------------


  $('.slick--sliderHome').each(function() {
    $(this).slick({
      infinite: false,
      loop: false,
      slidesToShow: 3,
      appendArrows: $(this).next('.slider__nav'),
      appendDots: $(this).next('.slider__nav'),
      arrows: true,
      dots: true,
      responsive: [{
        breakpoint: 1092,
        settings: {
          slidesToShow: 2,
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }]
    });
  });

  var homepageBannersSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
    appendDots: '.slick-dots-custom',
    infinite: true,
    loop: true,
    slidesToShow: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
      }
    }]
  };

  // -- Init --
  $('.slick--banners').slick(homepageBannersSettings);

  // // -- Prev --
  // $('.banners').on('click', '.arrow--prev', function(){
  //   $(this).parents('.banners').find('.slick--banners').slick('slickPrev');
  // });

  // // -- Next --
  // $('.banners').on('click', '.arrow--next', function(){
  //   $(this).parents('.banners').find('.slick--banners').slick('slickNext');
  // });


  var homepageBlockBannerSettings = {
    arrows: false,
    dots: true,
    infinite: false,
    loop: false,
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 768,
      settings: 'unslick'
    }]
  };

  // -- Init --
  $('.slick--blockBannerMob').slick(homepageBlockBannerSettings);


  // var homepageSliderSettings = {
  //   arrows: false,
  //   dots: true,
  //   infinite: false,
  //   loop: false,
  //   slidesToShow: 3,
  //   responsive: [{
  //     breakpoint: 1092,
  //     settings: {
  //       slidesToShow: 2,
  //     }
  //   },{
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1,
  //     }
  //   }]
  // };

  // // -- Init --
  // $('.slick--sliderHome').slick(homepageSliderSettings);

  // // -- Prev --
  // $('.section__slider').on('click', '.arrow--prev', function(){
  //   $(this).parents('.section__slider').find('.slick--sliderHome').slick('slickPrev');
  // });

  // // -- Next --
  // $('.section__slider').on('click', '.arrow--next', function(){
  //   $(this).parents('.section__slider').find('.slick--sliderHome').slick('slickNext');
  // });

});


$(window).on('resize orientationchange', function() {
  if ($(window).width() < 767) {
    if ($('.slick--blockBannerMob')) {
      $('.blockAnim').css({'margin-top':0});
      var homepageBlockBannerSettings = {
        arrows: false,
        dots: true,
        infinite: false,
        loop: false,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [{
          breakpoint: 768,
          settings: 'unslick'
        }]
      };
      $('.slick--blockBannerMob').slick(homepageBlockBannerSettings);
    }
  }
  // $('.slick-slider').slick('resize');
  
});